import {connect} from 'react-redux';

import {
  ExportContactsCsvJobModel,
  JobStatusesEnum,
} from '../../../../../../libs/shared/core/src/models/api/jobModel';
import {computeJobProgress} from '../../../../../../libs/shared/core/src/models/helpers/jobHelpers';
import {jobDeletedAction} from '../../../../../../libs/shared/core/src/store/data/jobs/commonJobsActions';
import {
  createSelector,
  makeMapDispatchToProps,
  makeMapStateToProps,
} from '../../../../../../srcCommon/helpers/reselectHelpers';
import {AppState} from '../../../../../store/appState';
import {getCompanyUrl} from '../../../../../store/data/company/companySelectors';
import {ContactsCsvExportBanner} from './contactsCsvExportBanner';

/*
 * Props.
 */

interface ContactsCsvExportBannerContainerProps {
  job: ExportContactsCsvJobModel;
}

/*
 * Selectors.
 */

function getJob(_state: AppState, props: ContactsCsvExportBannerContainerProps) {
  return props.job;
}

function makeGetProgress() {
  return createSelector([getJob], (job) => {
    const progress = computeJobProgress(job);
    // progress should be 0 when job is being initialized
    return job.status === JobStatusesEnum.INIT ? 0 : progress;
  });
}

function makeGetDownloadUrl() {
  return createSelector([getCompanyUrl, getJob], (url, job) => `${url}/card_exports/${job.id}/download`);
}

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<ContactsCsvExportBannerContainerProps>()(() => ({
  progress: makeGetProgress(),
  downloadUrl: makeGetDownloadUrl(),
}));

const mapDispatchToProps = makeMapDispatchToProps()(() => ({
  onDeleteJob: jobDeletedAction,
}));

export const ContactsCsvExportBannerContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(ContactsCsvExportBanner);
